export default __webpack_public_path__ + "static/media/yoda.6c19dbb9.jpg";